import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgJobNoLongerAvailableUrl from '@/assets/misc/img_job-no-longer-available.svg'
import JobNoLongerAvailableIllustration from '@/components/SpotIllustration/JobNoLongerAvailableIllustration'

export interface VanishedDialogProps {
  showing: boolean
  message: string
  onClose: () => unknown
  corporateMode: boolean
}

export function VanishedDialog({
  showing,
  message,
  onClose,
  corporateMode,
}: VanishedDialogProps) {
  return (
    <ModalSheet showing={showing}>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgJobNoLongerAvailableUrl}
              illustration={byDesign(
                undefined,
                JobNoLongerAvailableIllustration,
              )}
            />
          )}
          <ModalSheetContentTitle>
            This opportunity has vanished!
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            {message} The job is no longer available.
            <br />
            Please select another from the Opportunities screen.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
